import type { IAuthUser } from './AuthClient';

/**
 * The auth state which, when combined with the auth methods, make up the return
 * object of the `useAuth` hook.
 */
export type IAuthState = {
  error?: Error;
  isAuthenticated: boolean;
  isLogingIn: boolean;
  isLogingOut: boolean;
  user?: IAuthUser;
};

/**
 * The initial auth state.
 */
export const initialAuthState: IAuthState = {
  isAuthenticated: false,
  isLogingIn: true,
  isLogingOut: false,
};
